/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiSkeletonRectangle, EuiText } from '@elastic/eui'

export const SkeletonServiceItem = () => (
  <EuiFlexGroup justifyContent='spaceBetween'>
    <EuiFlexItem>
      <EuiFlexGroup direction='column' gutterSize='s'>
        <EuiFlexItem>
          <EuiFlexGroup gutterSize='s' alignItems='center'>
            <EuiFlexItem grow={false}>
              <EuiSkeletonRectangle width={90} height={24} />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiSkeletonRectangle width={100} height={24} />
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiSkeletonRectangle width={120} height={17} />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiText color='subdued' size='s'>
            <EuiSkeletonRectangle width={783} height={17} />
          </EuiText>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiFlexItem>
    <EuiFlexItem grow={false}>
      <EuiSkeletonRectangle width={51} height={16} />
    </EuiFlexItem>
  </EuiFlexGroup>
)
